"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.some.js");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _settings = require("@/settings");
var _user = require("@/api/user");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));
var _lodash = _interopRequireDefault(require("lodash"));
var _autoTableHeight = require("@/views/mixins/autoTableHeight");
var _index2 = _interopRequireDefault(require("../../../components/SearchBox/index.vue"));
var _role = require("@/api/role");
var _utils = require("@/utils");
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
var _organizations = require("@/api/organizations");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserList',
  directives: {
    elDragDialog: _elDragDialog.default
  },
  components: {
    UploadExcelComponent: _index.default,
    SearchBox: _index2.default
  },
  mixins: [_autoTableHeight.autoTableHeight],
  data() {
    return {
      Constants,
      statusList: _lifehikesInitData.userStatusList,
      userList: [],
      tableLoading: false /* use for el-table */,
      total: 0,
      query: {
        page: 1,
        limit: _settings.pageSize,
        q: undefined,
        status: undefined,
        role: undefined,
        baselineDone: undefined,
        sort: '-updatedAt',
        isLoop: undefined,
        organizationId: undefined
      },
      orgQuery: {
        // page:1,
        // limit:pageSize,
        sort: 'name:asc'
      },
      // Upload Dialog
      dialogVisible: false,
      newRoleList: _lifehikesInitData.newRoleList,
      lifehikesRoles: _lifehikesInitData.newRoleList.filter(p => p.type === 'LifeHikes'),
      delphiRoles: _lifehikesInitData.newRoleList.filter(p => p.type === 'Delphi'),
      userRole: Object.assign({}),
      userTenants: [],
      LifeHikesSelection: [],
      DelphiSelection: [],
      organizationList: [],
      userMetadata: {}
    };
  },
  computed: {
    showTenantDropdown() {
      if (!this.userRole || !this.userRole.role) return false;
      const allListRoleKeys = this.newRoleList.map(item => item.key);
      const preUserRoles = this.userRole.role.filter(item => !allListRoleKeys.includes(item));
      const currentRoles = this.LifeHikesSelection.map(i => i.key).concat(this.DelphiSelection.map(i => i.key), preUserRoles);
      if (currentRoles.includes(Constants.USER_ROLE_ROOT)) return true;
      return currentRoles.some(r => r !== Constants.USER_ROLE_PARTICIPANT);
    }
  },
  created() {
    this.getOrganizationList();
    this.getList();
  },
  methods: {
    hasPermission(value) {
      return (0, _permission.default)(value);
    },
    doDelete(uuid) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const email = (0, _cookie.getCookie)('EMAIL');
      this.tableLoading = true;
      (0, _user.deleteUserAccount)(token, uuid).then(response => {
        const data = response.data;
        // console.log('page-user-delete', response)

        (0, _log.displayPopupMessage)('User has been deleted successfully', 'success');
        (0, _ga.writeGaEvent)(this, 'User', 'Delete User', email, `User Profile: ${uuid}`);
        this.tableLoading = false;
        this.doSearch(this.query.page);
      }).catch(error => {
        this.tableLoading = false;
        (0, _log.showDebugLog)('Page-user-delete-Err', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    doSearch(page) {
      this.query.page = page;
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      this.query.status = this.query.status === '' ? undefined : this.query.status;
      this.query.baselineDone = '' ? undefined : this.query.baselineDone;
      this.query.isLoop = this.query.isLoop === '' ? undefined : this.query.isLoop;
      // this.query.role = 'otr-digital-producer,otr-coach'
      this.getList();
    },
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _user.getUserList)(token, this.query).then(response => {
        // create a new property newIsLoop to save checkbox value
        response.data.rows.forEach(row => {
          row.newIsLoop = row.isLoop;
        });

        // this.list = response.data.items
        this.userList = response.data.rows;
        this.total = response.data.count;
        this.tableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('GetUserList-api-error', error);
        this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    },
    handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$parent.$emit('onSelectionChange', val);
    },
    sort(data) {
      const {
        prop,
        order
      } = data;
      if (prop === 'givenName') {
        order === 'ascending' ? this.query.sort = '+givenName' : this.query.sort = '-givenName';
      }
      if (prop === 'familyName') {
        order === 'ascending' ? this.query.sort = '+familyName' : this.query.sort = '-familyName';
      }
      if (prop === 'displayName') {
        order === 'ascending' ? this.query.sort = '+displayName' : this.query.sort = '-displayName';
      }
      if (prop === 'email') {
        order === 'ascending' ? this.query.sort = '+email' : this.query.sort = '-email';
      }
      if (prop === 'orgName') {
        order === 'ascending' ? this.query.sort = '+orgName' : this.query.sort = '-orgName';
      }
      if (prop === 'status') {
        order === 'ascending' ? this.query.sort = '+status' : this.query.sort = '-status';
      }
      if (prop === 'updatedAt') {
        order === 'ascending' ? this.query.sort = '+updatedAt' : this.query.sort = '-updatedAt';
      }
      if (prop === 'createdAt') {
        order === 'ascending' ? this.query.sort = '+createdAt' : this.query.sort = '-createdAt';
      }
      if (prop === 'lastLoginDate') {
        order === 'ascending' ? this.query.sort = '+lastLoginDate' : this.query.sort = '-lastLoginDate';
      }
      if (prop === 'baselineDone') {
        order === 'ascending' ? this.query.sort = '+baselineDone' : this.query.sort = '-baselineDone';
      }
      this.doSearch(1);
    },
    confirmRole(uuid, userRole) {
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const email = (0, _cookie.getCookie)("EMAIL");
      // const roles = userRole.filter(r => r !== "root");
      let LifeHikesRoles = this.LifeHikesSelection.map(item => {
        return item.key;
      });
      let DelphiRolles = this.DelphiSelection.map(item => {
        return item.key;
      });
      let AllRolles = this.newRoleList.map(item => {
        return item.key;
      });
      let PreUserRoses = userRole.filter(item => !AllRolles.includes(item));
      const roles = LifeHikesRoles.concat(DelphiRolles, PreUserRoses).filter(r => r !== Constants.USER_ROLE_ROOT && r !== Constants.USER_ROLE_DEVELOPER //LHVO-4726 - Add developer role
      );
      (0, _role.updateUserRole)(token, uuid, roles).then(response => {
        const metadata = {
          ...this.userMetadata
        };
        if (this.showTenantDropdown) {
          metadata.tenants = this.userTenants || [];
        } else {
          metadata.tenants = [];
        }
        return (0, _user.updateUser)(token, uuid, {
          metadata
        });
      }).then(response => {
        const data = response.data;
        // console.log('page-permission-confirmrole', response)

        (0, _log.displayPopupMessage)("User's role (and tenents) has been updated successfully", "success");
        (0, _ga.writeGaEvent)(this, "User", "Update User Role", email, `User Profile: ${uuid}`);
        this.dialogVisible = false;
        this.doSearch(this.query.page);
      }).catch(error => {
        (0, _log.showDebugLog)("Page-permission-confirmrole-Err", error);
        (0, _log.displayPopupMessage)(error, "error");
      });
    },
    handleEdit(scope) {
      this.dialogVisible = true;
      this.userRole = (0, _utils.deepClone)(scope.row);
      this.userMetadata = _lodash.default.get(this.userRole, 'metadata') || {};
      this.userTenants = _lodash.default.get(this.userRole, 'metadata.tenants', []);
      this.checkData();
    },
    checkData() {
      this.$nextTick(function () {
        if (this.$refs.LifeHikesRolles) {
          this.$refs.LifeHikesRolles.clearSelection();
        }
        if (this.$refs.DelphiRolles) {
          this.$refs.DelphiRolles.clearSelection();
        }
        this.newRoleList.filter(p => p.type === "LifeHikes").forEach(row => {
          if (this.userRole.role.includes(row.key)) {
            this.$refs.LifeHikesRolles.toggleRowSelection(row, true);
          }
        });
        this.newRoleList.filter(p => p.type === "Delphi").forEach(row => {
          if (this.userRole.role.includes(row.key)) {
            this.$refs.DelphiRolles.toggleRowSelection(row, true);
          }
        });
      });
    },
    LifeHikesSelectionChange(val) {
      this.LifeHikesSelection = val;
    },
    DelphiSelectionChange(val) {
      this.DelphiSelection = val;
    },
    checkRoleSelectable(row) {
      if (row.key === 'admin') {
        return this.hasPermission(['root', 'admin']);
      }
      return true;
    },
    disableVisble(id) {
      //console.info(this.$refs[id]);
      this.$refs[id].visible = false;
    },
    getOrganizationList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _organizations.getAllOrganizations)(token, this.orgQuery).then(response => {
        this.organizationList = response.data.rows;
        this.tableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('getAllOrganizations-api-error', error);
        this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    }
  }
};